import { combineReducers } from 'redux';
import backendCompanyReducer from './company';
import backendEngagementSurveyReducer from './engagementSurvey';
import backendSegmentReducer from './segment';
import backendUiReducer from './ui';
import backendUserReducer from './user';

const backendReducer = combineReducers({
  user: backendUserReducer,
  ui: backendUiReducer,
  engagementSurvey: backendEngagementSurveyReducer,
  segment: backendSegmentReducer,
  company: backendCompanyReducer,
});

export default backendReducer;
